export default __webpack_public_path__ + "static/media/logoh.9298c523.svg";